<div class="editRoles__container">
  <div class="editRoles__header">
    <div class="editRoles__title">
      @switch (mode) {
      @case ('create') {
      Create Workflow
      }
      @case ('update') {
      Edit {{ workflowData?.name }}
      }
      @case ('view') {
      {{ workflowData?.name }}
      }
      @default {
      Workflow
      }
      }
    </div>
    <div class="editRoles__crossIcon" (click)="handleClosePopup({isClose : true})">
      <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
    </div>
  </div>
  <div class="workflowForm__contentWrapper">
    <form [formGroup]="workflowForm">

      <div class="d-flex row align-items-baseline">
        <div class="col-md-4">
          @if (mode !== 'view') {
          <app-input-filed placeholder="Enter Name" label="Name" [control]="$any(workflowForm).controls['name']"
            [value]="$any(workflowForm).controls['name'].value" name="name" [starIcon]="'*'"></app-input-filed>
          @if (workflowForm.get('name')?.invalid &&
          (workflowForm.get('name')?.dirty ||
          workflowForm.get('name')?.touched)) {
          <div class="alert_required">
            @if (workflowForm.get('name')?.errors?.['required']) {
            <div>
              <small class="text-danger">Name is
                required.</small>
            </div>
            }
          </div>
          }
          }
          @if (mode === 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Name
            </div>
            <div class="input-fieldValue">{{ workflowData?.name }}</div>
          </div>
          }

        </div>
        <div class="col-md-4">
          @if (mode !== 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Document Category
              @if (!isInvoiceTrackingEnabled) {
              <span style="color: chocolate;">*</span>
              }
            </div>
            <select class="select_dropdownOptions" formControlName="documentType">
              <option [value]="''" selected disabled>Select Document Category
              </option>
              @for (item of documentCategoryData; track item) {
              <option [ngValue]="item?._id">
                {{ item?.name }}
              </option>
              }
            </select>
            @if (workflowForm.get('documentType')?.invalid &&
            (workflowForm.get('documentType')?.dirty ||
            workflowForm.get('documentType')?.touched)) {
            <div class="alert_required">
              @if (workflowForm.get('documentType')?.errors?.['required']) {
              <div>
                <small class="text-danger">Document Category is
                  required.</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (mode === 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Document Category
            </div>
            <div class="input-fieldValue">{{ workflowData?.documentType?.name }}</div>
          </div>
          }
        </div>
        <div class="col-md-4">
          @if (mode !== 'view') {
          <app-input-filed placeholder="Enter description" label="Description"
            [control]="$any(workflowForm).controls['description']"
            [value]="$any(workflowForm).controls['description'].value" name="description"
            [starIcon]="'*'"></app-input-filed>
          @if (workflowForm.get('description')?.invalid &&
          (workflowForm.get('description')?.dirty ||
          workflowForm.get('description')?.touched)) {
          <div class="alert_required">
            @if (workflowForm.get('description')?.errors?.['required']) {
            <div>
              <small class="text-danger">Description is
                required.</small>
            </div>
            }
          </div>
          }
          }
          @if (mode === 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Description
            </div>
            <div class="input-fieldValue">{{ workflowData?.description }}</div>
          </div>
          }

        </div>
      </div>

      <div>
        <div class="stage-header">
          <h2 class="stage-title">Authorization Stages
            <span class="file-icon" placement="right" data-bs-toggle="tooltip"
              [ngbTooltip]="'Either Department or Users is mandatory to select for each stage.'">
              <app-common-icon [faIcon]="faInfoCircle"></app-common-icon>
            </span>
          </h2>
        </div>

        <div formArrayName="stages">
          @for (stage of stages.controls; track $index; let i = $index; let last = $last) {
          <div [formGroupName]="i" class="stage-box">
            <div class="stage-container">
              <div class="d-flex align-items-center justify-content-between">
                @if (mode !== 'view') {
                <div class="stage-subtitle"></div>
                }
                @if (mode !== 'view') {
                <div class="d-flex gap-2">
                  @if (stages.length > 1) {
                  <div class=" text-center">
                    <fa-icon [icon]="faTrash" class="delete_faicon" (click)="removeStage(i)">
                    </fa-icon>
                  </div>
                  }
                  @if (last) {
                  <div class=" text-center">
                    <fa-icon [icon]="faSquarePlus" class="delete_faicon" (click)="addStage()">
                    </fa-icon>
                  </div>
                  }
                </div>
                }
              </div>
              <div class="row d-flex align-items-baseline">
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <app-input-filed placeholder="Enter Name" label="Name"
                    [control]="$any(stageControls(i)).controls['name']" name="name"
                    [value]="$any(stageControls(i)).controls['name'].value" [starIcon]="'*'"></app-input-filed>
                  @if (stageControls(i).controls['name']?.invalid &&
                  (stageControls(i).controls['name']?.dirty ||
                  stageControls(i).controls['name']?.touched)) {
                  <div class="alert_required">
                    @if (stageControls(i).controls['name']?.errors?.['required']) {
                    <div>
                      <small class="text-danger">Name is
                        required.</small>
                    </div>
                    }
                  </div>
                  }
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Name
                    </div>
                    <div class="input-fieldValue">
                      {{workflowData?.stages[i]?.name}}</div>
                  </div>
                  }
                </div>
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Department
                    </div>
                    <select class="select_dropdownOptions" formControlName="department"
                      (change)="onDepartmentChange(i)">
                      <option [value]="''" selected>Select Department
                      </option>
                      @for (item of departmentsData; track item) {
                      <option [ngValue]="item?._id">
                        {{ item?.name }}
                      </option>
                      }
                    </select>
                    @if (stageControls(i).errors?.['atLeastOneSelect'] && stageControls(i).touched) {
                    <div class="alert_required">
                      <small class="text-danger">Please select atleast one Department or Users</small>
                    </div>
                    }
                  </div>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Department
                    </div>
                    <div class="input-fieldValue">
                      {{workflowData?.stages[i]?.departments[0]?.departmentName}}</div>
                  </div>
                  }
                </div>
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Users
                    </div>
                    <app-auto-search-dropdown style="position: relative;" placeholder="Users" (click)="getUsersList(i)"
                      [isMultiSelect]="true" (selectedValues)="onSelectUser(i, $event)"
                      [previousSeletedValues]="stageControls(i).controls['users']?.value" (loadMore)="getUsersList(i)"
                      [listData]="usersList" (searchText)="getUsersList(i, $event)">
                    </app-auto-search-dropdown>
                    @if (stageControls(i).errors?.['atLeastOneSelect'] && stageControls(i).touched) {
                    <div class="alert_required">
                      <small class="text-danger">Please select atleast one Department or Users</small>
                    </div>
                    }
                  </div>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Users
                    </div>
                    <div class="input-fieldValue">
                      {{ workflowData?.stages[i]?.users?.length > 0
                      ? workflowData?.stages[i]?.users[0]?.name + ' (' + workflowData?.stages[i]?.users[0]?.emailAddress
                      + ')'
                      : '-' }}
                      @if (workflowData?.stages[i]?.users?.length > 0) {
                      <span class="dots" data-bs-toggle="dropdown" aria-expanded="false">
                        +more
                      </span>
                      }
                      <ul class="dropdown-menu">
                        @for (user of workflowData?.stages[i]?.users; track user) {
                        <li class="dropdown-item">{{user?.name +'
                          ('+user?.emailAddress+')'}}</li>
                        }
                      </ul>
                    </div>
                  </div>
                  }
                </div>
              </div>
              <div class="row d-flex align-items-baseline pt-3">
                <div class="select_dropdown col-md-4">
                
                  @if (mode !== 'view') {
                  <div class="select_dropdownLabel">
                    Approval Type<span style="color: chocolate;">*</span>
                  </div>
                
                  <select class="select_dropdownOptions" formControlName="approvalType">
                    <option [value]="''" disabled>Select Approval Type</option>
                    @for (item of approvalTypes; track item.value) {
                      <option [ngValue]="item?.value">
                        {{ item?.name }}
                      </option>
                    }
                  </select>
                
                  @if (stageControls(i).controls['approvalType']?.invalid &&
                  (stageControls(i).controls['approvalType']?.dirty ||
                  stageControls(i).controls['approvalType']?.touched)) {
                
                  <div class="alert_required">
                    @if (stageControls(i).controls['approvalType']?.errors?.['required']) {
                    <small class="text-danger">Approval Type is required.</small>
                    }
                  </div>
                  }
                  }
                
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Approval Type
                    </div>
                    <div class="input-fieldValue">
                      {{workflowData?.stages[i]?.approvalType | titlecase}}
                    </div>
                  </div>
                  }
                
                </div>
                <div class="select_dropdown col-md-4" formGroupName="notifications">
                  @if (mode !== 'view') {
                  <div class="select_dropdownLabel">
                    Remainder Type<span style="color: chocolate;">*</span>
                  </div>
                  <select class="select_dropdownOptions" formControlName="reminderType">
                    <option [value]="''" selected disabled>Select Remainder Type
                    </option>
                    @for (item of remainderTypeData; track item) {
                    <option [ngValue]="item?.value">
                      {{ item?.name }}
                    </option>
                    }
                  </select>
                  @if (stageControls(i).get('notifications')?.controls['reminderType']?.invalid &&
                  (stageControls(i).get('notifications')?.controls['reminderType']?.dirty ||
                  stageControls(i).get('notifications')?.controls['reminderType']?.touched)) {
                  <div class="alert_required">
                    @if (stageControls(i).get('notifications')?.controls['reminderType']?.errors?.['required']) {
                    <div>
                      <small class="text-danger">Remainder Type is
                        required.</small>
                    </div>
                    }
                  </div>
                  }
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdownLabel">
                    Remainder Type
                  </div>
                  <div class="input-fieldValue">
                    {{$any(stageControls(i)).get('notifications').controls['reminderType'].value | titlecase}}
                  </div>
                  }
                </div>
                <div class="col-md-4" formGroupName="notifications">
                  @if (mode !== 'view') {
                  <app-input-filed placeholder="Reminder Period" label="Reminder Period"
                    [control]="$any(stageControls(i)).get('notifications').controls['reminderPeriod']"
                    [value]="$any(stageControls(i)).get('notifications').controls['reminderPeriod'].value"
                    name="numberOfDays" [starIcon]="'*'">
                  </app-input-filed>
                  @if (stageControls(i).get('notifications').controls['reminderPeriod']?.invalid &&
                  (stageControls(i).get('notifications').controls['reminderPeriod']?.dirty ||
                  stageControls(i).get('notifications').controls['reminderPeriod']?.touched)) {
                  <div class="alert_required">
                    @if (stageControls(i).get('notifications').controls['reminderPeriod']?.errors?.['required']) {
                    <div>
                      <small class="text-danger">Reminder Period is
                        required.</small>
                    </div>
                    }
                  </div>
                  }
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">Reminder Period</div>
                    <div class="input-fieldValue">{{ $any(stageControls(i)).get('notifications').controls['reminderPeriod'].value }}</div>
                  </div>
                  }
                </div>
              </div>
              <div class="row d-flex align-items-baseline pt-3">
                <div class="select_dropdown col-md-4">
                  @if (mode !== 'view') {
                  <div class="select_dropdownLabel">
                    Escalation Type
                  </div>
                  <select class="select_dropdownOptions" formControlName="escalationPeriod">
                    <option [value]="''" selected>Select Escalation Type</option>
                    @for (item of remainderTypeData; track item.value) {
                    <option [ngValue]="item?.value">
                      {{ item?.name }}
                    </option>
                    }
                  </select>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdownLabel">
                    Escalation Type
                  </div>
                  <div class="input-fieldValue">
                    {{ ($any(stageControls(i)).controls['escalationPeriod'].value | titlecase) || '-' }}
                  </div>
                  }
                </div>
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <app-input-filed placeholder="Enter Escalation Period" label="Escalation Period"
                    [control]="$any(stageControls(i)).controls['escalation']"
                    [value]="$any(stageControls(i)).controls['escalation'].value" name="escalation"
                    [allowedType]="'number'" [maxDigits]="4">
                  </app-input-filed>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">Escalation Period</div>
                    <div class="input-fieldValue">
                      {{ $any(stageControls(i)).controls['escalation'].value || '-' }}
                    </div>
                  </div>
                  }
                </div>
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Escalation User
                    </div>
                    <app-auto-search-dropdown class="position-relative" placeholder="Escalation User"
                      [isMultiSelect]="false" [showClearIcon]="true" (click)="getEscalationUsersList()"
                      (selectedValues)="onSelectEscalationUser(i, $event)"
                      [previousSeletedValues]="$any(stageControls(i)).controls['escalationUserName'].value"
                      (loadMore)="getEscalationUsersList(escalationQuery, true)" [listData]="escalationUsersList"
                      (searchText)="getEscalationUsersList($event)">
                    </app-auto-search-dropdown>
                  </div>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Escalation User
                    </div>
                    <div class="input-fieldValue">{{ getEscalationUserLabel(i) }}</div>
                  </div>
                  }
                </div>
              </div>
              <div class="skip-rules-section">
                <div class="skip-rules-header">
                  <span class="skip-rules-title">Conditional Metadata Skipping Rule</span>
                  @if (mode !== 'view') {
                  <fa-icon [icon]="faSquarePlus" class="delete_faicon" (click)="addSkipRule(i)"></fa-icon>
                  }
                </div>
              
                @if (mode !== 'view') {
                <div formArrayName="skipRules">
                  @if (getSkipRules(i).length === 0) {
                  <p class="skip-rules-empty">No rules yet. Click <strong>+</strong> to add one.</p>
                  }
                  @for (rule of getSkipRules(i).controls; track $index; let ri = $index) {
                  <div [formGroupName]="ri" class="skip-rule-row">
                    <div class="d-flex align-items-start gap-2">
                      <div class="skip-field">
                        <app-input-filed placeholder="Enter Metadata Field" label="Metadata Field"
                          [control]="$any(skipRuleControl(i, ri)).controls['metadataField']"
                          [value]="$any(skipRuleControl(i, ri)).controls['metadataField'].value" name="metadataField"
                          [starIcon]="'*'">
                        </app-input-filed>
                        @if (skipRuleControl(i, ri).get('metadataField')?.invalid &&
                        (skipRuleControl(i, ri).get('metadataField')?.dirty || skipRuleControl(i, ri).get('metadataField')?.touched))
                        {
                        <small class="text-danger">Metadata Field is required.</small>
                        }
                      </div>
              
                      <!-- Metadata Type -->
                      <div class="skip-field">
                        <div class="select_dropdown">
                          <div class="select_dropdownLabel">Metadata Type<span style="color: chocolate;">*</span></div>
                          <select class="select_dropdownOptions" formControlName="metadataType"
                            (change)="onMetadataTypeChange(i, ri)">
                            @for (type of metadataTypes; track type.value) {
                            <option [value]="type.value">{{ type.label }}</option>
                            }
                          </select>
                        </div>
                      </div>
              
                      <!-- Condition -->
                      <div class="skip-field">
                        <div class="select_dropdown">
                          <div class="select_dropdownLabel">Condition<span style="color: chocolate;">*</span></div>
                          <select class="select_dropdownOptions" formControlName="condition">
                            <option value="" disabled>Select Condition</option>
                            @for (cond of getConditionsForType(skipRuleControl(i, ri).get('metadataType')?.value); track cond.value) {
                            <option [value]="cond.value">{{ cond.label }}</option>
                            }
                          </select>
                          @if (skipRuleControl(i, ri).get('condition')?.invalid &&
                          (skipRuleControl(i, ri).get('condition')?.dirty || skipRuleControl(i, ri).get('condition')?.touched)) {
                          <small class="text-danger">Condition is required.</small>
                          }
                        </div>
                      </div>
              
                      <!-- Condition Value -->
                      <div class="skip-field">
                        <app-input-filed placeholder="Enter Condition Value" label="Condition Value"
                          [control]="$any(skipRuleControl(i, ri)).controls['conditionValue']"
                          [value]="$any(skipRuleControl(i, ri)).controls['conditionValue'].value" name="conditionValue"
                          [starIcon]="'*'">
                        </app-input-filed>
                        @if (skipRuleControl(i, ri).get('conditionValue')?.invalid &&
                        (skipRuleControl(i, ri).get('conditionValue')?.dirty || skipRuleControl(i,
                        ri).get('conditionValue')?.touched)) {
                        <small class="text-danger">Condition Value is required.</small>
                        }
                      </div>
              
                      <!-- Next Stage on Skip -->
                      <div class="skip-field">
                        <div class="select_dropdown">
                          <div class="select_dropdownLabel">Next Stage on Skip<span style="color: chocolate;">*</span></div>
                          <select class="select_dropdownOptions" formControlName="nextStageOnSkip">
                            <option value="" disabled>Select Stage</option>
                            @for (s of getOtherStageNames(i); track s.value) {
                            <option [value]="s.value">{{ s.name }}</option>
                            }
                          </select>
                          @if (skipRuleControl(i, ri).get('nextStageOnSkip')?.invalid &&
                          (skipRuleControl(i, ri).get('nextStageOnSkip')?.dirty || skipRuleControl(i,
                          ri).get('nextStageOnSkip')?.touched)) {
                          <small class="text-danger">Next Stage On Skip is required.</small>
                          }
                        </div>
                      </div>
              
                      <!-- Delete rule -->
                      <div class="skip-delete">
                        <fa-icon [icon]="faTrash" class="delete_faicon" (click)="removeSkipRule(i, ri)"></fa-icon>
                      </div>
              
                    </div>
                  </div>
                  }
                </div>
                }
              
                @if (mode === 'view') {
                @if (workflowData?.stages[i]?.skipRules?.length > 0) {
                @for (rule of workflowData?.stages[i]?.skipRules; track $index; let ri = $index) {
                <div class="skip-rule-view-row">
                  <div class="row g-2">
                    <div class="col-md-3">
                      <div class="select_dropdown">
                        <div class="select_dropdownLabel">Metadata Field</div>
                        <div class="input-fieldValue">{{ rule.metadataField }}</div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="select_dropdown">
                        <div class="select_dropdownLabel">Type</div>
                        <div class="input-fieldValue">{{ rule.metadataType | titlecase }}</div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="select_dropdown">
                        <div class="select_dropdownLabel">Condition</div>
                        <div class="input-fieldValue">{{ rule.condition | titlecase }}</div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="select_dropdown">
                        <div class="select_dropdownLabel">Value</div>
                        <div class="input-fieldValue">{{ rule.conditionValue }}</div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="select_dropdown">
                        <div class="select_dropdownLabel">Skip to</div>
                        <div class="input-fieldValue">{{ rule.nextStageOnSkip }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                } @else {
                <p class="skip-rules-empty">No skipping rules defined.</p>
                }
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </form>

  </div>
  <div class="editRoles__footer">
    <div class="d-flex  gap-2">
      <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
        (click)="handleClosePopup({isClose : true})"></app-common-button>
      @if (commonService.orgLock() && mode !== 'view') {
      <app-common-button type="button" [loadingIcon]="verifyLoader" buttonClass="smallFilledButton" [buttonLabel]="mode === 'update' ? 'Update' : 'Save'"
        [disabled]="!workflowForm.valid" (clickEvent)="onSubmit()"></app-common-button>
      }
    </div>
  </div>
</div>

@if (showErorToaster) {
<app-error-toaster [title]="toasterMessage" (closeToaster)="closeToaster()"></app-error-toaster>
}